import React, { useState, useEffect } from "react";
import GuestsInput from "../GuestsInput";
import LocationInput from "../LocationInput";
import DatesRangeInput from "../DatesRangeInput";
import { GuestsObject } from "components/HeroSearchForm/type";
import converSelectedDateToString from "utils/converSelectedDateToString";

const StaySearchForm = () => {
  const [fieldNameShow, setFieldNameShow] = useState<"Hotel" | "Fechas" | "Huespedes">("Hotel");

  const [locationInputTo, setLocationInputTo] = useState("");
  const [guestInput, setGuestInput] = useState<GuestsObject>({
    guestAdults: 2,
    guestChildren: 0,
    guestInfants: 0,
  });

  // Inicializa startDate con la fecha actual
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  // Inicializa endDate agregando 3 días a la fecha actual
  const [endDate, setEndDate] = useState<Date | null>(() => {
    const today = new Date();
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + 3);
    return futureDate;
  });

  // Inicializa el estado en sessionStorage
  useEffect(() => {
    sessionStorage.setItem("mobile_form", "incomplete");
  }, []);

  // Verifica si todos los campos están completos
  useEffect(() => {
    if (
      locationInputTo &&
      startDate &&
      endDate &&
      (guestInput.guestAdults > 0 || guestInput.guestChildren > 0)
    ) {
      sessionStorage.setItem("mobile_form", "completed");
    } else {
      sessionStorage.setItem("mobile_form", "incomplete");
    }
  }, [locationInputTo, startDate, endDate, guestInput]);

  const canOpenNext = (field: "Hotel" | "Fechas" | "Huespedes") => {
    const formStatus = sessionStorage.getItem("mobile_form");
    if (formStatus === "completed") return true;
    if (fieldNameShow === "Hotel" && locationInputTo) return true;
    if (fieldNameShow === "Fechas" && startDate && endDate) return true;
    return false;
  };

  const renderInputLocation = () => {
    const isActive = fieldNameShow === "Hotel";
    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 ${
          isActive ? "rounded-2xl shadow-lg" : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => canOpenNext("Hotel") && setFieldNameShow("Hotel")}
          >
            <span className="text-neutral-400">Donde?</span>
            <span>{locationInputTo || "Hotel"}</span>
          </button>
        ) : (
          <LocationInput
            defaultValue={locationInputTo}
            onChange={(value) => {
              setLocationInputTo(value);
              setFieldNameShow("Fechas");
            }}
          />
        )}
      </div>
    );
  };

  const renderInputDates = () => {
    const isActive = fieldNameShow === "Fechas";
    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 overflow-hidden ${
          isActive ? "rounded-2xl shadow-lg" : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => canOpenNext("Fechas") && setFieldNameShow("Fechas")}
          >
            <span className="text-neutral-400">Cuando?</span>
            <span>
              {startDate && endDate
                ? converSelectedDateToString([startDate, endDate])
                : "Agregar fecha"}
            </span>
          </button>
        ) : (
          <DatesRangeInput

          />
        )}
      </div>
    );
  };

  const renderInputGuests = () => {
    const isActive = fieldNameShow === "Huespedes";
    let guestSelected = "";
    if (guestInput.guestAdults || guestInput.guestChildren) {
      const guest = (guestInput.guestAdults || 0) + (guestInput.guestChildren || 0);
      guestSelected += `${guest} personas`;
    }

    if (guestInput.guestInfants) {
      guestSelected += `, ${guestInput.guestInfants} infantes`;
    }

    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 overflow-hidden ${
          isActive ? "rounded-2xl shadow-lg" : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => canOpenNext("Huespedes") && setFieldNameShow("Huespedes")}
          >
            <span className="text-neutral-400">Quien?</span>
            <span>{guestSelected || `Agregar huespedes`}</span>
          </button>
        ) : (
          <GuestsInput defaultValue={guestInput} onChange={setGuestInput} />
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="w-full space-y-5">
        {renderInputLocation()}
        {renderInputDates()}
        {renderInputGuests()}
      </div>
    </div>
  );
};

export default StaySearchForm;